class LoaderHelper {
  static loader:any;

  static setLoader(loader:any) {
    this.loader = loader;
  }

  static loaderStatus(flag:any) {
    
    if (this.loader) {
      this.loader.updateStatus(flag);
    }
  }
}

export default LoaderHelper;
